import React from 'react';
import LoadingGif from "./icons/LoadingGif";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { withCommonConfig } from '../hooks/CommonConfigContext';
class Loading extends React.Component {
    render() {
        const { labels: localized } = this.props.CommonConfig || {};

        return (
            <div data-cy="fele=loading" className="fele-loading">
                {!this.props.type && (
                    <div className="simple">
                        <FontAwesomeIcon icon={faSpinner} pulse />
                        <span>{localized?.Loading || 'Loading...'}</span>
                    </div>
                )}
                {this.props.type === "brand" && (
                    <div className="brand">
                        <div className="logo">
                            <LoadingGif />
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default withCommonConfig(Loading);
